import { https , httpsFile } from './http.js' ;

export function login ( data ) {
    return https().post( 'login' , data )
    .then(response => {
        if(response.status === 200){
            setToken(response.data);
        }
        return response;
    })
}

export function logout () {
    httpsFile().post( 'auth/logout' ) ;
    // sessionStorage.removeItem( 'user-info' ) ;
    this.removeLocalStorage();
}

export function preference () {
    // const token = sessionStorage.getItem ( 'user-info' ) ;
    const token = localStorage.getItem('user') ;
    if( !token ) {
        return null ;
    } 
    const token_data = JSON.parse ( token ) ;
    return token_data.token_type + ' ' + token_data.access_token ;
}

export function userData () {
    // const user_data = sessionStorage.getItem ( 'user-info' ) ;
    const user_data = localStorage.getItem ( 'user-info' ) ;

    let user;
        // let user_data_json = JSON.parse(user_data);
        // user = user_data_json.user;

    return JSON.parse(user_data);
}

export function userData2 () {

    const user_data2 = localStorage.getItem ( 'user' ) ;

    if(!user_data2){
        return null;
    }

    return JSON.parse(user_data2);
}

export function authenticated(){
    // const token = sessionStorage.getItem('user-info');
    const token = localStorage.getItem('user');
    return token != null;
}

export function setUserData(data){
    // const user_data = sessionStorage.getItem('user-info') ;
    const user_data = localStorage.getItem('user') ;
    let user_data_json = JSON.parse(user_data);
    user_data_json.user = data;
    setToken(user_data_json);
}

export function removeLocalStorage(){
    localStorage.removeItem( 'user-info' ) ;
    localStorage.removeItem( 'user' ) ;
    localStorage.removeItem("permissions");
    localStorage.removeItem("roles");
}

function setToken(data){
    // sessionStorage.setItem('user-info', JSON.stringify(data));
    console.log(data);
    localStorage.setItem('user-info', JSON.stringify(data));
    localStorage.setItem("user",JSON.stringify(data));
}
